import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrCode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_15742_203313",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 3.66699,
				y: 3.66602,
				width: 4.26667,
				height: 4.26667,
				rx: .8
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.66699,
			y: 3.66602,
			width: 4.26667,
			height: 4.26667,
			rx: .8,
			stroke: "currentColor",
			strokeWidth: 1,
			mask: "url(#path-1-inside-1_15742_203313)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-2_15742_203313",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 3.66699,
				y: 10.0664,
				width: 4.26667,
				height: 4.26667,
				rx: .8
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.66699,
			y: 10.0664,
			width: 4.26667,
			height: 4.26667,
			rx: .8,
			stroke: "currentColor",
			strokeWidth: 1,
			mask: "url(#path-2-inside-2_15742_203313)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-3-inside-3_15742_203313",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 10.0664,
				y: 3.66602,
				width: 4.26667,
				height: 4.26667,
				rx: .8
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.0664,
			y: 3.66602,
			width: 4.26667,
			height: 4.26667,
			rx: .8,
			stroke: "currentColor",
			strokeWidth: 1,
			mask: "url(#path-3-inside-3_15742_203313)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5997,
			cy: 10.5997,
			r: .5,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .0666666
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.7999,
			cy: 10.5997,
			r: .5,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .0666666
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.7999,
			cy: 13.7999,
			r: .5,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .0666666
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5997,
			cy: 13.7999,
			r: .5,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .0666666
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.2003,
			cy: 12.1993,
			r: .5,
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .0666666
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 1H1.8C1.35817 1 1 1.35817 1 1.8V5",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 1H16.2C16.6418 1 17 1.35817 17 1.8V5",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 17H16.2C16.6418 17 17 16.6418 17 16.2V13",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 17H1.8C1.35817 17 1 16.6418 1 16.2V13",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgQrCode;
